module.exports = __webpack_public_path__ + "d99df0d45145f44603f7d84a1ff495b5.svg";